import { WorkspaceV1, WorkspaceV2 } from "./types.generated";

export const defaultWorkspaceLogo =
  "https://media.cartographer.io/static/images/workspaces/demo.png";

export function workspaceLogo(workspace: WorkspaceV1 | WorkspaceV2): string {
  return workspace.logo == null ? defaultWorkspaceLogo : workspace.logo;
}
